import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import { MenuItem } from 'src/app/components/top-menu/top-menu.component';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MenuService } from '../modules/shared/services/menu.service';

@Directive({
    selector: '[appActiveMenuItem]',
    standalone: false
})
export class ActiveMenuItemDirective implements OnInit {
    private el = inject(ElementRef);
    private router = inject(Router);
    private menuService = inject(MenuService);

    @Input('appActiveMenuItem') menuItem: MenuItem;
    activeClass = 'active';

    ngOnInit(): void {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                if (this.menuService.isMenuActive(this.menuItem)) {
                    this.el.nativeElement.classList.add(this.activeClass);
                } else {
                    this.el.nativeElement.classList.remove(this.activeClass);
                }
            });
    }
}
